import { AUTHORPOSTSEARCHED, CATEGORYSEARCHED, SEARCHED } from "./actionTypes";
import initialState from "./initialState";

const filterReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEARCHED:
            return {
                ...state,
                input: action.payload,
            };
        case CATEGORYSEARCHED:
            return {
                ...state,
                categoryInput: action.payload,
            };
        case AUTHORPOSTSEARCHED:
            return {
                ...state,
                authorInput: action.payload,
            };
        default:
            return state;
    }
};

export default filterReducer;
